import { useEffect, useState } from 'react';

import { getAllAlaAgreements, deleteAlaAgreement, patchAlaAgreement } from '../../api';

export const useAlaAggrements = () => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);

  const deleteItems = ids => async () => {
    updateLoading(true);
    const response = await deleteAlaAgreement({ alaAgreementIds: ids });

    updateLoading(false);
    if (response) {
      if (Array.isArray(ids)) {
        updateData(data.filter(item => ids.indexOf(item.id) === -1));
      } else {
        updateData(data.filter(item => item.id !== ids));
      }
      updateLoading(false);
    }
  };

  const updateStatusRecords = async (ids, status, file, comments) => {
    updateLoading(true);
    const entities = ids.map(id => ({ id, comments }));
    const response = await patchAlaAgreement({ entities, approvalAction: status }, file);

    if (response) {
      const updatedData = data.map((item) => {
        const itemIndex = response.findIndex(updated => updated.id === item.id);
        if (itemIndex > -1) {
          item.status = response[itemIndex].status;
          item.comments = response[itemIndex].comments;
          item.fileName = response[itemIndex].fileName;
          item.approverUsername = response[itemIndex].approverUsername;
          item.statusUpdateDate = response[itemIndex].statusUpdateDate;
        }

        return item;
      });

      updateData(updatedData);
      updateLoading(false);
    }
  };

  useEffect(() => {
    const getAll = async () => {
      updateLoading(true);
      let response = await getAllAlaAgreements();
      updateLoading(false);

      if (response) {
        response = response.map((item) => {
          const origin = item.origin.map(originItem => originItem.value);
          const destination = item.destination.map(destinationItem => destinationItem.value);
          return { ...item, origin, destination };
        });
        updateData(response);
      }
    };

    getAll();
  }, []);

  return [data, loading, deleteItems, updateStatusRecords];
};
